import { toFilter } from 'utils/widgetUtil'
import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { SearchFilterComposingStrategy } from './strategy/searchFilterComposing/searchFilterComposingStrategy'

export const composeDetailSearchFilter = (
  strategy: SearchFilterComposingStrategy,
  widgetSetting: DashboardWidgetType,
  insights: InsightData[]
) => strategy.composeDetailSearchFilter(toFilter(widgetSetting), insights, widgetSetting)

export default composeDetailSearchFilter
